module.exports = __webpack_public_path__ + "static/media/19ESCAP39.28be36ab.jpg";